import { createVNode as _createVNode } from "vue";
/**
 * @author yili
 * @fileoverview 轮播
 */
import _ from "lodash";
import { defineComponent, onMounted, watch, reactive, nextTick } from "vue";
import Swiper from "swiper";
import "swiper/css/swiper.css";

// components
export default defineComponent({
  name: "InformationSwiperBox",
  props: {
    // 轮播信息
    swiperSetInfo: {
      type: Object,
      default: null
    }
  },
  setup(props) {
    const state = reactive({
      mySwiper: null
    });
    watch(() => props.swiperSetInfo, newVal => {
      if (state.mySwiper) {
        // bool1代表是否销毁swiper实例
        // bool2代表是否销毁swiper样式（导航器、分页器等）
        state.mySwiper.destroy(true, false);
      }
      nextTick(() => {
        initSwiper(newVal.type, newVal.slidesPerView, newVal.initialSlide, newVal.spaceBetween);
        // state.mySwiper.update();
      });
    }, {
      deep: true
    });
    function initSwiper(key, slidesIndex, initialIndex, spaceBetweenIndex) {
      state.mySwiper = new Swiper(`.${key}`, {
        // autoplay: {
        //   disableOnInteraction: false, // 用户操作swiper之后，是否禁止autoplay
        //   delay: 3000, // 自动切换的时间间隔（单位ms）
        // },
        observer: true,
        //修改swiper自己或子元素时，自动初始化swiper
        observeParents: true,
        //修改swiper的父元素时，自动初始化swiper
        slidesPerView: slidesIndex,
        initialSlide: initialIndex,
        //设定初始化时slide的索引,下标从0开始
        spaceBetween: spaceBetweenIndex,
        //间隔
        loop: true,
        // 是否循环轮播
        breakpoints: true,
        zoom: true,
        circular: true,
        // 是否采用衔接滑动
        parallax: true,
        centeredSlides: true,
        // 居中
        speed: 500,
        watchOverflow: true,
        //当没有足够的slide切换时,默认不开启这个功能
        pagination: {
          el: ".swiper-pagination",
          type: "bullets",
          bulletClass: "swiper-pagination-bullet",
          //激活样式
          bulletActiveClass: "my-bullet-active"
        }
        // navigation: {
        //   nextEl: ".swiper-button-next",
        //   prevEl: ".swiper-button-prev",
        // },
      });
    }

    onMounted(() => {
      if (props.swiperSetInfo.type) {
        initSwiper(props.swiperSetInfo.type, props.swiperSetInfo.slidesPerView, props.swiperSetInfo.initialSlide, props.swiperSetInfo.spaceBetween);
      }
    });
    return () => {
      const item = _.map(props.swiperSetInfo.slideList, item => {
        return _createVNode("div", {
          "class": "swiper-slide",
          "key": item
        }, [_createVNode("a", {
          "href": item.url
        }, [_createVNode("img", {
          "src": item.image
        }, null)])]);
      });
      return _createVNode("div", {
        "class": "box"
      }, [_createVNode("div", {
        "class": `swiper-container ${props.swiperSetInfo.type} ${props.swiperSetInfo.key}`,
        "id": `${props.swiperSetInfo.key}`
      }, [_createVNode("div", {
        "class": "swiper-wrapper"
      }, [item]), _createVNode("div", {
        "class": "swiper-pagination-box"
      }, [_createVNode("div", {
        "class": "text"
      }, [item.image_title || ""]), _createVNode("div", {
        "class": "swiper-pagination"
      }, null)])])]);
    };
  }
});